<template>
    <div class="map" :class="phoneClass || 'home-container-wrapper'">
        <!-- 地图 -->
        <div id="container"></div> 
    </div>
</template>

<script>
import Core from "core/core";
import MapLoader from './amap'
export default {
    name: 'Map',
    components: {},
    props: {},
    data() {
        return {
            deviceList: [],
            map: null,
            phoneClass: '',
            page: 1,
            allMarkers: [],
            timer: null,
        }
    },
    watch: {},
    computed: {},
    created() {},
    mounted() {
        this.initMap();
        let a = { lat: 30.269229572413717, lng: 120.15012286544209 };
        let b = { lat: 30.248508308452006, lng: 120.19595645308851 };
        console.log(Math.sqrt((a.lat - b.lat) * (a.lat - b.lat) + (b.lng - a.lng) * (b.lng - a.lng)))
    },
    methods: {
        initMap() {
            let that = this
            MapLoader().then(AMap => {
                // 加载地图
                that.map = new AMap.Map("container", {
                    resizeEnable: true,
                    zoom: 20,
                    keyboardEnable: false
                })
                that.map.on('moveend', that.mapRefleshMarker);
                that.map.on('zoomend', that.mapRefleshMarker);
                console.log("加载成功")
                that.getDeviceList()
            }) 
        },
        mapRefleshMarker() {
            this.removeMarkers();
            if(this.timer) clearTimeout(this.timer);
            this.timer = setTimeout(()=>{
                this.getDeviceList();
                this.timer = null;
            },500)
            // console.log(zoom, center);
        },
        // async getDeviceList() {
        getDeviceList() {
            const ths = this;

            // 0.7072851（大概杭州市范围）zoom:(0-13)
            // 0.14991373155585122 (大概杭州市西湖区范围) zoom:(13-15)
            // 0.05029998545440807 (大概杭州市西湖学院路-凤起路直径) zoom:(16-20)
            let zoom = this.map.getZoom(); //获取当前地图级别
            let center = this.map.getCenter(); //获取当前地图级别
            // console.log(zoom, center);
            // return;
            let offset= 0.7072851;
            if(zoom > 13) offset = 0.14991373155585122;
            if(zoom > 15) offset = 0.05029998545440807;
            Core.Api.Device.getMapDeviceList(center.lng, center.lat, offset)
                .then((res)=>{
                    console.log('res: ', res);
                    if(res.list.length) {
                        // ths.deviceList = ths.deviceList.concat(res.list)
                        ths.deviceList = res.list || [];
                        ths.addMarkers(res.list);
                        // if(ths.deviceList.length <= 1000) {
                        //     ths.addMarkers(res.list);
                        //     ths.page++;
                        //     ths.getDeviceList();
                        // } else {
                        //     ths.$message.warning('请缩小地图查看！');
                        //     return;
                        // }
                    }
                }).catch( err => {

                })
        },
        removeMarkers(){
            this.map.remove(this.allMarkers);
        },
        addMarkers(val) {
            console.log("val", val)
            const ths = this;
            val.forEach(item => {
                if(item.longitude !== "" && item.latitude !== "") {
                    // 添加marker
                    let position = [item.longitude, item.latitude]
                    let marker = new AMap.Marker({
                        position
                    })
                    this.allMarkers.push(marker);
                    this.map.add(marker)
                    // this.map.setFitView(); // 根据marker自适应zoom
                    console.log("添加成功")
                    // 添加点击事件
                    marker.on('click', (e) => {
                        console.log('item: ', item);
                        let info = []
                        let infoWindow
                        let iconEle = Core.Const.MAP.icon_ele   //电量图标
                        let address = item.address ? item.address: "-" // 位置信息
                        let iconEleWidth = (item.battery_power > 100 ? 100 : (item.battery_power || 0)) + '%'   // 电池图标宽度
                        let iconEleBg = item.battery_power <= 20 ? '#eb202a' : '#46962b' // 电量css
                        let statusText = "" // 状态文字
                        let statusStyle = "" // 状态框样式
                        let rssiImage = ths.getSignalImgByRSSINew(item.rssi / 10);
                        switch(item.status) {
                            case 0: {
                                statusText = ths.$t('selectData.device.status.status0')
                                statusStyle = "color:black;background: #88c008"
                            }; break;
                            case 1: {
                                statusText = ths.$t('selectData.device.status.status1')
                                statusStyle = "color:black;background: yellow"
                            }; break;
                            case 2: {
                                statusText = ths.$t('selectData.device.status.status2')
                                statusStyle = "color:black;background: red"
                            } ; break;
                            case 3: {
                                statusText = ths.$t('selectData.device.status.status3')
                                statusStyle = "color:white;background: #99a5aa"
                            }; break;
                            case 4: {
                                statusText = ths.$t('selectData.device.status.status4')
                                statusStyle = "color:white;background: #99a5aa"
                            }; break;
                        }
                        if(item.pending_setting === 0) {
                            statusText = ths.$t('selectData.device.status.pending_setting')
                            statusStyle = "color:black;background: #F8E71C"
                        }
                        // info窗口第一行内容
                        if(item.status === 3) {
                            info.push(`
                                <div class="map-tip-top">
                                    <div style="color:#363D42;">${item.uid}</div>
                                    <div style="${statusStyle};padding:5px">${statusText}</div>
                                </div>`)
                        }
                        // 信号
                        info.push(`<div class="map-info-line">
                           <span>${ ths.$t('devicePage.signal') }: &nbsp;</span><img src="${rssiImage}" style="height: 25px;width: 25px" alt="">
                        </div>`)
                        // 电量
                        info.push(`<div class="map-info-line">
                            <span>${ ths.$t('devicePage.quantity') }: &nbsp;</span>
                            <div style="width:26px;height:15px;position:relative;">
                                <img src="${iconEle}" style="position:absolute;left:-1px;top:-1px;height:17px">
                                <div style="width:${iconEleWidth};background:${iconEleBg};height:15px"></div>
                            </div>
                        </div>`)
                        // 活跃时间
                        info.push(`<div class="map-info-line">
                            <span>${ ths.$t('devicePage.activeTime') }: &nbsp;${address || '暂无'}</span>
                        </div>`)
                        // 地址
                        info.push(`<div class="map-info-line">
                            <span>${ ths.$t('dealerPage.address') }: &nbsp;${address || '暂无'}</span>
                        </div>`)
                        infoWindow = new AMap.InfoWindow({
                            content: info.join("")
                        })
                        console.log('position: ', position);
                        let infoPosition = position.map(item => {
                            return Number(item) + 0.00001
                        })
                        console.log('infoPosition: ', infoPosition);
                        infoWindow.open(ths.map, infoPosition);
                    })
                }
            })
        },
	    getSignalImgByRSSINew(rssi) {
	        if (rssi > -75) {
	            return require("../../assets/img/rssi/signal5.png");
	        } else if (rssi > -85 && rssi <= -75 ) {
	            return require("../../assets/img/rssi/signal4.png");
	        } else if (rssi > -95 && rssi <= -85 ) {
	            return require("../../assets/img/rssi/signal3.png");
	        } else if (rssi > -105 && rssi <= -95) {
	            return require("../../assets/img/rssi/signal2.png");
	        } else if (rssi > -115 && rssi <= -105) {
		        return require("../../assets/img/rssi/signal1.png");
	        } else if (rssi <= -115 ) {
	            return require("../../assets/img/rssi/signal0.png");
	        }

	    },
    },
}
</script>

<style lang='scss' scoped>
.home-container-wrapper {
    width: 100%;
    height: 100%;
    #container {
        width: 100%;
        height: 100%;
    }
}

</style>

<style lang='scss'>
.map-tip-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    // background: rgba(15, 88, 214, 0.1);
    margin-top: 10px;
    // padding: 10px;
    width: 202px;
    font-size: 14px;
    font-weight: bold;
    line-height: 14px;
}
.map-info-line {
    display: flex;
    // justify-content: flex-start;
    justify-content: flex-start;
    align-items: center;
    height: 25px;
    line-height: 25px;
    // vertical-align: middle;
}
</style>